/*
 *
 * SavingWallet actions
 *
 */

import { createAction } from '@reduxjs/toolkit';
import savingWalletConstants from './constants';
import { WalletSummaryResponse, WalletTransactionsResponse } from '../../apischema/savingwallet';

export const getWalletSummary = createAction(
  savingWalletConstants.GET_WALLET_SUMMARY,
);

export const getWalletSummarySuccess = createAction(
  savingWalletConstants.GET_WALLET_SUMMARY_SUCCESS,
  function prepare(data: WalletSummaryResponse) {
    return { payload: { data } };
  },
);

export const getWalletSummaryError = createAction(
  savingWalletConstants.GET_WALLET_SUMMARY_ERROR,
  function prepare(error: string) {
    return { payload: { error } };
  },
);

export const setPreviousPoints = createAction(
  savingWalletConstants.SET_PREVIOUS_POINTS,
  function prepare(previousPoints: number) {
    return { payload: { previousPoints } };
  },
);

export const showMilestoneCelebration = createAction(
  savingWalletConstants.SHOW_MILESTONE_CELEBRATION,
  function prepare(milestone: number) {
    return { payload: { milestone } };
  },
);

export const hideMilestoneCelebration = createAction(
  savingWalletConstants.HIDE_MILESTONE_CELEBRATION,
);

export const getWalletTransactions = createAction(
  savingWalletConstants.GET_WALLET_TRANSACTIONS,
);

export const getWalletTransactionsSuccess = createAction(
  savingWalletConstants.GET_WALLET_TRANSACTIONS_SUCCESS,
  function prepare(data: WalletTransactionsResponse) {
    return { payload: { data } };
  },
);

export const getWalletTransactionsError = createAction(
  savingWalletConstants.GET_WALLET_TRANSACTIONS_ERROR,
  function prepare(error: string) {
    return { payload: { error } };
  },
);
